"use client";

import { useCompositeContainer } from "../__chunks/4NBJGM6Q.js";
import { useToolbarItem } from "../__chunks/BOLVLGVE.js";
import "../__chunks/P2CTZE2T.js";
import "../__chunks/RZ4GPYOB.js";
import "../__chunks/KUU7WJ55.js";
import "../__chunks/5VQZOHHZ.js";
import { useToolbarContext } from "../__chunks/A3WPL2ZJ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-container.tsx
var TagName = "div";
var useToolbarContainer = createHook(function useToolbarContainer2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useToolbarContext();
  store = store || context;
  props = useCompositeContainer(__spreadValues({
    store: store
  }, props));
  props = useToolbarItem(__spreadValues({
    store: store
  }, props));
  return props;
});
var ToolbarContainer = memo(forwardRef(function ToolbarContainer2(props) {
  var htmlProps = useToolbarContainer(props);
  return createElement(TagName, htmlProps);
}));
export { ToolbarContainer, useToolbarContainer };